import {
  CreateGUFAddRealisedInstallationTask,
  CreateGUFExpandedRealisedInstallationTask,
  EditGUFAddRealisedInstallationTask,
  EditGUFExpandedRealisedInstallationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

import { realisedScreenSchema } from "./guf-realised-screen-schema";

/**
 * Schema for RealisedWell within a RealisedInstallation.
 * validity and lifespan are included here; they are excluded in the
 * ExpandedRealisedInstallation schema via a separate schema variant.
 */
export const realisedWellSchema = addSchema<
  (
    | CreateGUFAddRealisedInstallationTask
    | EditGUFAddRealisedInstallationTask
  )["sourcedocumentData"]["realisedWells"]
>({
  type: "array",
  title: "Gerealiseerde putten",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde put",
    required: ["realisedWellId", "wellFunctions", "height", "wellDepth", "wellPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "realisedWellId",
        "wellFunctions",
        "height",
        "wellDepth",
        "wellPos",
        "publiclyAvailable",
        "relativeTemperature",
        "validity",
        "lifespan",
      ]),
      realisedScreens: realisedScreenSchema,
    },
  },
});

/**
 * Same as realisedWellSchema but without validity and lifespan.
 * Used by GUF_ExpandedRealisedInstallation.
 */
export const realisedWellExpandedSchema = addSchema<
  (
    | CreateGUFExpandedRealisedInstallationTask
    | EditGUFExpandedRealisedInstallationTask
  )["sourcedocumentData"]["realisedWells"]
>({
  type: "array",
  title: "Gerealiseerde putten",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde put",
    required: ["realisedWellId", "wellFunctions", "height", "wellDepth", "wellPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "realisedWellId",
        "wellFunctions",
        "height",
        "wellDepth",
        "wellPos",
        "publiclyAvailable",
        "relativeTemperature",
      ]),
      realisedScreens: realisedScreenSchema,
    },
  },
});
